// Basit i18n yapısı
const translations = {
  tr: {
    common: {
      language: "Dil",
      turkish: "Türkçe",
      english: "İngilizce",
    },
    cookieBanner: {
      text: "Bu sitede, kullanıcı deneyimini geliştirmek ve internet sitesinin verimli çalışmasını sağlamak amacıyla çerezler kullanılmaktadır. Şirketimiz ve ziyaretçi bilgilerinin korunmasıyla ilgili daha detaylı bilgi için _Çerez Politikamıza_ bakabilirsiniz.",
      accept: "Tamam",
      header: "Çerez Politikası",
    },
    navigation: {
      home: "Ana Sayfa",
      solutions: "Çözümlerimiz",
      insights: "İçgörüler",
      about: "Hakkımızda",
      blog: "Blog",
      login: "Giriş",
      demoRequest: "Demo talep edin",
      talkToTeam: "Ekibimizle konuşun",
    },
    hero: {
      title: "AI-Temelli Çalışan ve Ekosistem Deneyimiyle Geleceğin İş Modelini Şekillendirin",
      subtitle:
        "Gerçek zamanlı geri bildirimleri, kanıta dayalı aksiyonlara dönüştürün. Liderleri güçlendirin, çalışanları dahil edin ve iş sonuçlarını iyileştiren bilim temelli içgörüler ve kişiselleştirilmiş önerilerle sürdürülebilir bir iş yeri inşa edin.",
      cta: "Demo talep edin",
      learnMore: "Daha Fazla Bilgi",
    },
    services: {
      title: "Hizmetlerimiz",
      subtitle: "İhtiyaçlarınıza özel çözümler",
      ai: "Yapay Zeka",
      machineLearning: "Makine Öğrenmesi",
      dataAnalytics: "Veri Analizi",
      demoButton: "Demo Talep Edin",
      title1: "Görünmeyeni görün",
      description1: "Bilim temelli anketlerdeki açık uçlu yanıtları yapay zeka ile analiz edin, sorunları ayıklayın.",
      statText1: "Kullanıcı",
      title2: "Anlık analizle proaktif olun.",
      description2: "Sorunları tespit edin, bilimin ve en iyi uygulamaların ışığında önceliklendirin ve hazırlığınızı yapın.",
      statText2: "Ülke",
      title3: "Doğru içgörüyle harekete geçin.",
      description3: "Kurumunuza, liderlerinize ve çalışanlarınıza özel yol haritası ve aksiyon önerilerini kullanın.",
      statText3: "Organizasyon",
      text1: "Verileri anlık olarak analiz edin.",
      text2: "Stratejik kararlar için güçlü içgörüler elde edin.",
      text3: "Performansınızı metriklerle takip edin.",
      text4: "Zaman tasarrufu sağlayın.",
      text5: "Operasyonel hataları azaltın.",
      text6: "Verimliliği en üst düzeye çıkarın.",
      text7: "Sistemler arası uyumu sağlayın.",
      text8: "Tüm veriyi tek noktada yönetin.",
      text9: "Verimliliği ve kontrolü artırın.",
      title4: "Anketinizle bir koç gibi konuşabildiğinizi düşünün!",
      subtitle2: "Senswise AI sizi dinler, analiz eder ve nokta atışı öneriler sunar.",
    },
    contact: {
      title: "İletişim",
      subtitle: "Bizimle iletişime geçin",
      name: "Ad Soyad",
      email: "E-posta",
      message: "Mesaj",
      send: "Gönder",
    },
    tabSection: {
      title1: "Duygu Analizi ve Anadilde Güvenilir İçgörü ile Görünmeyeni Ortaya Çıkarın",
      title2: "Gerçek zamanlı ihtiyaçlarınıza özel uyarlanabilir ve kişiselleştirilmiş anketler.",
      title3: "Binlerce açık uçlu yanıtı, temalara göre yönetici özetlerine dönüştürün.",
      title4: "Anket sonuçlarınızla konuşun: Sorular sorun, açık uçlu yanıtların içinden anında içgörüler ortaya çıkarın.",
      title5: "Kurum, liderler ve ekip üyeleri için bilimsel kıyaslamalar ve Fortune 500 şirketlerinin en iyi uygulamalarına dayalı kişiye özel aksiyon planları sunar.",
      title6: "Nobel ödüllü davranış bilimiyle yapay zekayı birleştiriyoruz;",
      title7: "kurumların içgüdülerle değil, kanıta dayalı aksiyonlarla ilerlemesini sağlıyoruz.",
      subtitle: "Müşteri Yorumları",
      label1: "SenseAI",
      label2: "Dinleme Mekanizması",
      label3: "Akıllı Özetleme",
      label4: "Konuşan İçgörü",
      description1:
        "Çok alanlı modeller, geri bildirim ve yorumların arkasındaki duyguları sınıflandırır.\n\nİş dünyasına özel açık uçlu yanıtları analiz eden yapay zekâ destekli NLP modelimiz, Türkçede %90, Azericede %87 güvenilirlik sağlıyor. Kendi dilinizde, güvenle aksiyona geçin.",
      description2: "Sorular, yanıtlayan kişinin rolüne ve verdiği yanıtlara göre akıllıca şekillenir; ne uzatır ne sıkar. İlgili, etkili ve her zaman nokta atışı.",
      description3:
        "Çalışanların memnun olmadıkları ya da tavsiye etmedikleri konular için çözüm önerileri sunduğu alanları ayrı bir başlıkta görün.\n\nTüm özetler; güçlü yönlerden sorunlu alanlara kadar, en anlamlı temalar altında otomatik olarak kategorize ediliyor.",
      description4:
        "Uzun raporlar arasında kaybolmayın. Sadece sorunuzu yazın; yapay zekâ, çalışanların gerçek yorumlarına dayalı verilerle yanıtlasın. Rol, ekip ya da duyguya göre filtreleyerek gerçekten önemli olanı bulun.",
      title: "Müşteri Yorumları",
    },
    showcaseSection: {
      title: "Değer yarattığımız iş ortaklarımız",
    },
    testimonialsSection: {
      title: "İçgörüden Aksiyona: İş Ortaklarımız Ne Diyor",
      subtitle:
        "Lider kurumların Senswise ile çalışanlarını daha iyi dinlediğini, daha hızlı aksiyon aldığını ve bilim temelli yapay zekâ içgörüleriyle nasıl anlamlı değişim yarattığını görün.",
      position1: "Organizasyonel Gelişim; Performans Yönetimi Direktörü",
      comment1:
        "Senswise, kusursuz anket deneyimi ve gerçek zamanlı, anonim analitiği ile öne çıkmakta, içgörü toplamayı ve küresel ölçekte etkili kararlar almayı zahmetsiz hale getirmektedir",
      position2: "İK Müdürü",
      comment2: "Senswise hızlı sonuçlar elde etmemize yardımcı oldu ve çalışan memnuniyetinde net bir ilerleme sağladı. Küçük bir şirket için muazzam bir değer sunuyor!",
      position3: "Genel Müdür",
      comment3:
        "Senswise, sürekli geri bildirim sağlayarak, iş birliğini geliştirerek ve süreçleri optimize ederek gerçek bir dönüşümü mümkün kıldı. Elde edilen içgörüler, çalışan bağlılığını ve katılımını önemli ölçüde artırdı. Senswise sadece bir platform değil, aynı zamanda başarımızda stratejik bir ortak.",
    },
    platformVisualSection: {
      title: "Senswise: Geleceği Anlayan Yapay Zekâ",
      description:
        "Çalışan deneyimini sadece ölçmekle kalmayan, onu anlayan, yorumlayan ve yön veren bir yapay zekâ platformu. Senswise, çok dilli NLP motoru, yapay zekâ destekli Query Engine’i ve anlık içgörü üreten algoritmalarıyla, organizasyonları daha çevik, öngörülü ve insana duyarlı hale getiriyor. Çalışan refahını, kapsayıcılığı ve kurumsal sürdürülebilirliği destekleyerek UN Sustainable Development Goals (SDG) hedeflerine de hizmet ediyor.",
      title1: "Yaşam Döngüsü Deneyimi",
      title2: "Bütüncül İnsan Odaklı Yaklaşım",
      title3: "Çok Dilli Yapay Zekâ Asistanı (Agent)",
      text1: "MIT Sloan’a göre, çalışan deneyiminin tüm aşamalarını (işe alım, gelişim, ayrılık) kapsayan veri analizi, organizasyonel çevikliği %35 artırıyor.",
      text2:
        "Deloitte araştırmaları, yılda bir yapılan bağlılık ölçümlerinin aksiyon almakta geç kaldığını; çoklu zamanlı trend analizleri yapan şirketlerin %30 daha hızlı karar aldığını ortaya koyuyo",
      text3:
        "Senswise, çalışan yaşam döngüsünü uçtan uca izleyen yapay zekâ destekli algoritmalarıyla; dönemsel bağlılık trendlerini tespit eder, riskli dönemleri erkenden görünür kılar ve yöneticilere aksiyon önerileri sunar.",
      text4: "Harvard Business Review’a göre, psikolojik ve sosyal ihtiyaçları tanıyan kurumlar, uzun vadede %28 daha sürdürülebilir performans sergiliyor.",
      text5: "Columbia University bulguları, duygusal bağlılığı yüksek ekiplerin kültürel değişime 2,5 kat daha hızlı adapte olduğunu gösteriyor.",
      text6:
        "Senswise, çalışanların açık uçlu geri bildirimlerini NLP tabanlı yapay zekâ ile analiz eder; görünmeyen risk sinyallerini (tükenmişlik, anlam eksikliği, düşük görünürlük) ortaya çıkarır ve organizasyonel eğilimleri anlamlandırır.",
      text7:
        "TÜBİTAK destekli çalışmamız ile geliştirilen yapay zekâ motoru, Türkçe açık uçlu geri bildirimleri %0.90; Azerbaycan dilindeki verileri ise %0.87 doğrulukla analiz eder ve her iki dilde de aktif olarak kullanılır.",
      text8:
        "Query Engine özelliğimiz sayesinde yöneticiler, anket verilerine doğal dilde sorular sorabilir; sistem, binlerce açık uçlu yanıtı özetleyerek anlaşılır ve aksiyona dönüştürülebilir içgörülerle yanıt verir.",
      text9: "Senswise, İngilizce ve diğer diller için geliştirdiği çok dilli NLP altyapısıyla, bölgesel başarıyı küresel ölçeğe taşıyacak güçlü bir teknoloji sunuyor.",
    },
    contactSection: {
      title: "Bizimle İletişime Geçin",
      send: "Gönder",
      name: "İsim",
      surname: "Soyisim",
      email: "E-posta Adresiniz",
      phone: "Telefon Numaranız",
      position: "Pozisyonunuz",
      organization: "Organizasyonunuz",
      employeeCount: "Çalışan Sayısı Seçin",
      message: "Lütfen mesajınızı yazınız",
      openRiza: "İletişim Formu Açık Rıza Metnini",
      openRizaText: "okudum ve kabul ediyorum.",
      personalData: "İletişim Formu Kişisel Veri Aydınlatma Metnini",
      personalDataText: "okudum ve anladım.",
      successTitle: "Teşekkürler. Görüşlerinizi aldık.",
      successText: "Mesajınız başarıyla iletildi. En kısa sürede size geri dönüş yapacağız.",
      errors: {
        name: "Lütfen adınızı girin.",
        lastname: "Lütfen soyadınızı girin.",
        email: "Geçerli bir e-posta adresi girin.",
        phone: "Telefon numarası gereklidir.",
        position: "Pozisyonunuzu belirtin.",
        organization: "Organizasyon adı giriniz.",
        employeeCount: "Çalışan sayısını seçiniz.",
        text: "Lütfen mesajınızı yazınız.",
        personalData: "Lütfen kişisel veri aydınlatma metnini kabul ediniz.",
      },
    },
    blogList: {
      title: "Blog Yazıları",
      blog1: {
        title: "Evrensel Psikolojik İhtiyaçları anlamak neden önemlidir? ",
        content: `3 Evrensel Psikolojik İhtiyaç, her şeyden önce insan olduğumuzu, ardından çalışan olduğumuzu gösterir. Tıpkı fiziksel ihtiyaçlarımız; su, yemek ve barınma gibi, 3 evrensel psikolojik ihtiyaç hem iş hem özel yaşam için kaçınılmaz temel bir ihtiyaçtır.

3 temel ihtiyaç; yaşımız, cinsiyetimiz, kültürümüz, iş veya özel hayatımız, bireysel tercihlerimize bağlı olmaksızın herkes için geçerlidir. Araştırmalara göre bu 3 psikolojik ihtiyaç karşılandığı sürece, deneyim ve bağlılık en yüksek seviyeye ulaşır.

3 psikolojik ihtiyacınızın organizasyonunuzda ve ekibinizde karşılanma durumuyla ilgili ne düşünüyorsunuz?

1 - Güven

İş birliği ve dostluk
Saygı ve çeşitlilik
Destek ve özen
2 - Yetkinlik

Yetenek ve uzmanlık
Gelişim ve ilerleme
Takdir ve geri bildirim
3 - Özerklik

Sorumluluk ve risk yönetimi
Katılımcı karar verme
Seçme özgürlüğü`,
        date: "By Hediye Kızıl Ulu",
      },
      blog2: {
        title: "Kariyerinizden Memnun musunuz?",
        content: `Kariyer memnuniyeti, bireyin kendi belirlediği standartlara göre kendi kariyer başarısına yönelik algısıdır.

Gelir, statü, terfi, gelişme fırsatları, örgütsel kültür ve bağlılık, iş-yaşam dengesi, işveren markası ve bilinirliği, ilerleme fırsatları dahil olmak üzere örgütsel faktörler kariyer memnuniyeti ile güçlü bir şekilde ilişkilidir.

Ekibinizin ve organizasyonunuzun kariyer memnuniyetini ve motivasyon kaynaklarını anlayın. Çalışma arkadaşlarımızın deneyimlerini geliştirecek ve hedefleri ortak bir noktada buluşturacak bilimsel içgörüler ve stratejik aksiyonlar ile onlara kariyer yolculuklarında eşlik edin.

1 - Amaç

Bireysel hedef
Kariyer opsiyonları
2 - Şu anki rol deneyimi

Ücret ve haklar
Gelişim ve terfi fırsatları
İş birliği ve destek
Rol memnuniyeti
3 - Organizasyonel bağ

Bağlılık ve etkinlik
Ayrılma riski
    `,
        date: "By Burcu Alsan",
      },
      blog3: {
        title: "Sürdürülebilir Çalışan Yaşam Döngüsü neden önemlidir?",
        content: ` Çalışma arkadaşlarınızın organizasyon, kariyer ve yaşam dönüm noktaları hakkında uçtan uca bir anlayış kazanın. Organizasyonunuzun, liderlerinizin ve sizin çalışma arkadaşlarımızın deneyimleri üzerindeki etkisini görün.

Bu bilim temelli ankette, Ekonomi dalında Nobel ödüllü Psikolog Daniel Kahneman'ın Zirve-Son kuralı'ndan ilham aldık. Deneyimlerin zirveye ulaştığı ve sona erdiği, en az 35 dönüm noktasına ve kilometre taşına - gerçek anlara - odaklanın.

Her bir dönüm noktasının tavsiye skorunu ölçün. Ekibinizin ve organizasyonunuzun sonuçlarına göre en iyi uygulamaları ve bilimsel içgörüleri inceleyin. İnsan odaklı bir iş ortamı tasarlamak için anlamlı ve somut adımlar atın.

Organizasyonel dönüm noktası (Yemek, teknoloji deneyimi vb.)
Kariyer dönüm noktası (Terfi, rotasyon, emeklilik deneyimi vb.)
Yaşam dönüm noktası (Önemli birinin doğumu, boşanma, önemli bir hastalık teşhisi vb.)`,
        date: "By Burcu Alsan",
      },
    },
    footer: {
      about: "Senswise Hakkında",
      aboutUs: "Bizi Tanıyın",
      blog: "Blog",
      requestDemo: "Demo İsteyin",
      talkToOurTeam: "Ekibimizle Konuşun",
      mission: "Misyonumuz",
      getToKnowUs: "Bizi Tanıyın",
      allRightsReserved: "Tüm hakları saklıdır.",
      copyright: "SENSE Danışmanlık ve Teknoloji Çözümleri A.Ş.",
      address: "Adreslerimiz",
      documents: "Kişisel Veriler",
      cookies: "Çerez Politikası",
    },
    documents: {
      title: "Belgeler",
      subtitle: "Yasal belgelerimizi ve politikalarımızı buradan görüntüleyebilirsiniz.",
      clickToView: "Görüntülemek için tıklayın",
      noDocuments: "Henüz belge eklenmemiş.",
      list: {
        doc1: "Site Üyesi Aydınlatma Metni",
        doc2: "Privacy Policy",
        doc3: "İletişim Formu Açık Rıza Metni",
        doc4: "Çerez Politikası",
        doc5: "İlgili Kişi Başvuru Formu",
        doc6: "İletişim Formu Aydınlatma Metni",
        doc7: "Çalışan Adayı Aydınlatma Metni",
      },
    },
    mission: {
      title: "Misyonumuz",
      description:
        "Yapay zeka ve en güncel teknolojileri kullanarak topluluk ve insan davranışlarını bilgece anlamayı, organizasyonların daha güçlü bağlar kurmasını ve sürdürülebilir etki yaratmasını sağlamak.",
      card1: {
        title: "Topluluk Merkezli Yaklaşım",
        description: "Toplulukların ihtiyaç ve değerlerini önceliklendiriyor, ortak bir amaç duygusunu güçlendiriyoruz.",
      },
      card2: {
        title: "Bilgelik Odaklı İnovasyon",
        description: "Yapay zeka ve en güncel teknolojileri kullanarak içgörülü, anlamlı ve uygulanabilir çözümler sunuyoruz.",
      },
      card3: {
        title: "Empati ve Etki",
        description: "Gelişmiş teknolojiyi empatiyle dengeleyerek, çözümlerimizin organizasyonlar ve toplum üzerinde olumlu, sürdürülebilir bir değişim yaratmasını sağlıyoruz.",
      },
    },
    faqSection: {
      title: "Sıkça Sorulan Sorular",
      question1: "Anket, e-posta adresime kişisel bir bağlantı linki ile gönderilir. Cevaplarım gizli mi?",
      answer1:
        "Senswise'da verdiğiniz yanıtlar gizlidir. Gizliliğin, herkesin eşit şekilde duyulmasını sağlamak ve özellikle önemli olan konuları gündeme getirmekten asla rahatsızlık duymamanızı garanti edebilmemiz için çok önemli olduğuna inanıyoruz. Platform kullanıcıları, insan kaynakları veya yöneticiniz dahil olmak üzere organizasyonunuzdaki hiç kimse belirli bir yanıtı kimin verdiğini göremez. Yanıtlar, kişilerin kimliğinin tespit edilememesi için daha küçük ekiplerde birleştirilir. Sonuç puanının oluşması için soruyu, organizasyonun büyüklüğüne bağlı olarak en az 3 veya 5 kişinin cevaplamas",
      question2: "Senswise nedir? İnsan odaklı yapay zeka tam olarak nasıl çözüm sağlar?",
      answer2:
        "Senswise, verileri doğru bir şekilde toplamanıza, gerçek zamanlı olarak analiz etmenize, anlamlı içgörüler sağlamanıza ve organizasyonunuza, ekibinize ve kişisel ihtiyaçlarınıza özel stratejik aksiyon haritası önermeye yardımcı olmak için tasarlanmış bir çalışan deneyimi çözümüdür. Senswise, yalnızca organizasyonları değil, aynı zamanda ekip liderlerini ve tüm çalışanları en kritik sorunları ele alma konusunda yetkilendirir. Anket soruları, bilim destekli olmalarına rağmen anlaşılması kolay ve açık, samimi, günlük bir dille tasarlanmıştır. Doğru duyulmanızı sağlamak için dinleme mekanizmalarını tasarlarken insan bilimini ve veri bilimini bir araya getiriyoruz. Senswise'a göre, sağlıklı bir organizasyon, ancak organizasyonun, ekip liderlerinin, tüm çalışanlarıyla beraber çalışan memnuniyeti, elde tutma gibi önemli konuları birlikte düşünmeye ve bunlar üzerinde birlikte hareket etmeye başladığında mümkündür.",
    },
  },
  en: {
    common: {
      language: "Language",
      turkish: "Turkish",
      english: "English",
    },
    cookieBanner: {
      text: "Cookies are used on this website to enhance user experience and ensure the efficient operation of the site. For more detailed information regarding the protection of visitor data and our company practices, please refer to our _Cookie Policy_.",
      accept: "Accept",
      header: "Cookie Policy",
    },
    navigation: {
      home: "Home",
      solutions: "Solutions",
      insights: "Insights",
      about: "About",
      blog: "Blog",
      login: "Login",
      demoRequest: "Book a demo",
      talkToTeam: "Talk to Our Team",
    },
    hero: {
      title: "Shape the Future of Work with AI-Based Employee and Ecosystem Experience",
      subtitle:
        "Turn real-time feedback into evidence-based actions.Empower leaders, engage employees, and build a sustainable workplace with science-backed insights and personalized recommendations that improve business outcomes.",
      cta: "Book a demo",
      learnMore: "Learn More",
    },
    services: {
      title: "Our Services",
      subtitle: "Custom solutions for your needs",
      statText1: "Users",
      statText2: "Countries",
      statText3: "Organizations",
      ai: "Artificial Intelligence",
      machineLearning: "Machine Learning",
      dataAnalytics: "Data Analytics",
      demoButton: "Request Demo",
      title1: "See the invisible",
      description1: "Analyze open-ended questions of science-backed surveys with AI and detect problems.",
      title2: "Be proactive with instant analysis",
      description2: "Identify problems, prepare and prioritize with science and best practices",
      title3: "Take action with right insight",
      description3: "Use the road map and action suggestions specific to your organization, leaders, employees",
      text1: "Analyze data in real-time.",
      text2: "Get strong insights for strategic decisions.",
      text3: "Track your performance with metrics.",
      text4: "Save time.",
      text5: "Reduce operational errors.",
      text6: "Maximize efficiency.",
      text7: "Ensure system interoperability.",
      text8: "Manage all data in one place.",
      text9: "Increase efficiency and control.",
      title4: "What if you could talk to your survey like a coach?",
      subtitle2: "That’s what Senswise AI does - listens, interprets, and recommends.",
    },
    contactSection: {
      title: "Contact Us",
      send: "Send",
      name: "Full Name",
      surname: "Surname",
      email: "Email",
      phone: "Phone Number",
      position: "Position",
      organization: "Organization",
      employeeCount: "Select Employee Count",
      message: "Please write your message",
      openRiza: "Contact Form Open Consent Text",
      openRizaText: "I have read and accepted.",
      personalData: "Contact Form Personal Data Disclosure Text",
      personalDataText: "I have read and understood.",
      successTitle: "Thanks. We received your feedback.",
      successText: "Your message has been sent successfully. We will get back to you as soon as possible.",
      errors: {
        name: "Please enter your name.",
        lastname: "Please enter your surname.",
        email: "Please enter a valid email address.",
        phone: "Phone number is required.",
        position: "Please enter your position.",
        organization: "Please enter your organization name.",
        employeeCount: "Please select employee count.",
        text: "Please enter your message.",
        personalData: "Please accept the personal data disclosure.",
      },
    },
    blogList: {
      title: "Blog Articles",
      blog1: {
        title: "Why Understanding Universal Psychological Needs is Important",
        content: `The 3 Universal Psychological Needs show that we are human beings first — and employees second.
Just like our physical needs such as water, food, and shelter, these 3 universal psychological needs are fundamental and indispensable for both work and personal life.

These 3 core needs apply to everyone — regardless of age, gender, culture, work or personal life, or individual preferences.
Research shows that when these 3 psychological needs are met, experience and engagement reach their highest levels.

How do you think your 3 psychological needs are being met in your organization and team?

1 - Trust

Collaboration and friendship
Respect and diversity
Support and care
2 - Competence

Talent and expertise
Growth and advancement
Recognition and feedback
3 - Autonomy

Responsibility and risk management
Participatory decision-making
Freedom of choice

`,
        date: "By Hediye Kızıl Ulu",
      },
      blog2: {
        title: "Are You Happy with Your Career?",
        content: `Career satisfaction is an individual’s perception of their own career success based on their self-defined standards.

Organizational factors such as income, status, promotion, development opportunities, organizational culture and commitment, work-life balance, employer brand and recognition, and advancement opportunities are strongly associated with career satisfaction.

Understand the career satisfaction and sources of motivation within your team and organization.
Accompany our colleagues on their career journey with scientific insights and strategic actions that enhance their experiences and align their goals.

1 - Purpose

Individual goal
Career options
2 - Current role experience

Compensation and benefits
Development and promotion opportunities
Collaboration and support
Role satisfaction
3 - Organizational connection

Commitment and effectiveness
Turnover risk`,
        date: "By Burcu Alsan",
      },
      blog3: {
        title: "Why is the Sustainable Employee Life Cycle Important?",
        content: `Gain an end-to-end understanding of your colleagues’ organizational, career, and life milestones.
See the impact of your organization, your leaders, and yourself on the experiences of our colleagues.

In this science-based survey, we were inspired by Nobel Prize-winning Psychologist Daniel Kahneman’s Peak-End Rule in Economics.
Focus on at least 35 milestones and turning points – real moments – where experiences peak and end.

Measure the recommendation score of each milestone.
Explore best practices and scientific insights based on the results of your team and organization.
Take meaningful and concrete steps to design a human-centered work environment.

Organizational milestone (Meal, technology experience, etc.)
Career milestone (Promotion, rotation, retirement experience, etc.)
Life milestone (Birth of a loved one, divorce, major illness diagnosis, etc.)`,
        date: "By Burcu Alsan",
      },
    },

    footer: {
      about: "Senswise About",
      aboutUs: "Get to Know Us",
      blog: "Blog",
      requestDemo: "Request Demo",
      talkToOurTeam: "Talk to Our Team",
      mission: "Mission",
      getToKnowUs: "Get to Know Us",
      allRightsReserved: "All rights reserved.",
      copyright: "SENSE Consulting and Technology Solutions A.Ş.",
      address: "Our Addresses",
      documents: "Personal Data Protection",
      cookies: "Cookie Policy",
      documentsText: "You can visit the _Documents_ page to view our legal documents and policies.",
    },
    documents: {
      title: "Documents",
      subtitle: "You can view our legal documents and policies here.",
      clickToView: "Click to view",
      noDocuments: "No documents have been added yet.",
      list: {
        doc1: "Site Member Disclosure Text",
        doc2: "Privacy Policy",
        doc3: "Contact Form Explicit Consent Text",
        doc4: "Cookie Policy",
        doc5: "Data Subject Application Form",
        doc6: "Contact Form Disclosure Text",
        doc7: "Job Candidate Disclosure Text",
      },
    },
    tabSection: {
      title1: "See the invisible with Sentiment Analysis and Trusted Intelligence in Native Languages",
      title2: "Adaptive and personalized surveys tailored to your organization’s real-time needs.",
      title3: "Transform thousands of open-texts into theme-based executive summaries.",
      title4: "Talk to your survey results: Ask questions and instantly surface insights from open comments.",
      title5: "Provides scientific comparisons and personalized action plans based on Fortune 500 best practices for organizations, leaders, and team members.",
      title6: "We combine Nobel-winning behavioral science with AI to help organizations ",
      title7: "move from gut feeling to evidence-based action.",
      label1: "SenseAI",
      label2: "Listening Mechanism",
      label3: "Smart Summarization",
      label4: "Conversational Insight",
      description1:
        "Multi-domain models classify emotions behind feedbacks and comments.\n\nOur AI-powered NLP model delivers 0.90 reliability in Turkish and 0.87 in Azerbaijani when analyzing open-ended survey responses in work life, so you can act with confidence, in your own language.",
      description2: "Questions get smarter as they go; adapting to each respondent’s persona and answers without overwhelming them. Relevant, engaging, and always to the point.",
      description3:
        "See a separate focus area where employees offer suggestions due to dissatisfaction or low recommendation. \n\nAll insights are automatically categorized — from strengths to pain points — across themes that matter most.",
      description4:
        "No more digging through long reports. Just type your question — and our AI answers with evidence from real employee voices. Filter by role, team, or sentiment to pinpoint what really matters.",
    },
    showcaseSection: {
      title: "Our business partners we create value with",
    },
    testimonialsSection: {
      title: "From Insight to Action: What Our Partners Say",
      subtitle: "Discover how leading organizations use Senswise to listen better, act faster and build stronger cultures through science-backed and AI-native insights.",
      position1: "Organizational Development; Performance Management Director",
      comment1:
        "Senswise stands out with its seamless survey experience and real-time, anonymous analytics, making it effortless to gather insights and make impactful decisions on a global scale.",
      position2: "Head of HR",
      comment2: "Senswise helped us achieve fast results and made clear progress in employee satisfaction. It offers tremendous value for small company!",
      position3: "General Manager",
      comment3:
        "Senswise enabled real transformation by creating continuous feedback, improving collaboration, and optimizing processes. The insights significantly increased employee engagement and participation. More than a platform, Senswise is a strategic partner in our success.",
    },
    platformVisualSection: {
      title: "Senswise: AI That Understands the Future",
      description:
        "More than just measuring employee experience , Senswise understands it, interprets it, and helps leaders take action. With its multilingual NLP engine, AI-powered Query Engine, and real-time insight algorithms, Senswise transforms organizations into more agile, foresighted, and human-centered workplaces. It also contributes to the UN Sustainable Development Goals by supporting employee well-being, inclusion, and long-term organizational sustainability.",
      title1: "Employee Lifecycle Experience",
      title2: "Human-Centered Organizational Insight",
      title3: "Multilingual AI Agent",
      text1: "According to MIT Sloan, analyzing all stages of the employee lifecycle (onboarding, development, exit) increases organizational agility by 35%.",
      text2: "Deloitte research shows that annual engagement surveys often lead to delayed action, while companies using continuous trend analysis make decisions 30% faster.",
      text3: "Senswise uses AI-powered algorithms to track the full employee journey, identify trend shifts early, and provide managers with timely, actionable insights.",
      text4: "Harvard Business Review reports that organizations that address psychological and social needs achieve 28% more sustainable long-term performance.",
      text5: "Columbia University finds that teams with high emotional engagement adapt to cultural change 2.5 times faster.",
      text6:
        "Senswise uses NLP-based AI to interpret open-ended employee feedback, detect invisible signals (burnout, loss of meaning, low visibility), and map behavior patterns across the organization.",
      text7: "Backed by TÜBİTAK, our AI engine analyzes open-ended feedback in Turkish with 90% accuracy and in Azerbaijani with 87%, actively supporting both languages.",
      text8: "With our Query Engine feature, leaders can ask questions in natural language and receive actionable summaries derived from thousands of responses.",
      text9: "Senswise offers a powerful multilingual NLP infrastructure designed to scale from regional excellence to global impact.",
    },
    mission: {
      title: "Our Mission",
      description:
        "Using AI and the latest technologies, we aim to understand communities and human behavior scientifically, strengthen strong bonds between organizations, and create sustainable impact.",
      card1: {
        title: "Community-Centered Approach",
        description: "We prioritize the needs and values of communities, strengthen a shared purpose, and create a sense of belonging.",
      },
      card2: {
        title: "Knowledge-Driven Innovation",
        description: "We use AI and the latest technologies to provide science-backed, meaningful, and actionable solutions.",
      },
      card3: {
        title: "Empathy and Impact",
        description: "We balance advanced technology with empathy to create sustainable, positive change in organizations and communities.",
      },
    },
    faqSection: {
      title: "Frequently Asked Questions",
      question1: "Anket, e-posta adresime kişisel bir bağlantı linki ile gönderilir. Cevaplarım gizli mi?",
      answer1:
        "Senswise'da verdiğiniz yanıtlar gizlidir. Gizliliğin, herkesin eşit şekilde duyulmasını sağlamak ve özellikle önemli olan konuları gündeme getirmekten asla rahatsızlık duymamanızı garanti edebilmemiz için çok önemli olduğuna inanıyoruz. Platform kullanıcıları, insan kaynakları veya yöneticiniz dahil olmak üzere organizasyonunuzdaki hiç kimse belirli bir yanıtı kimin verdiğini göremez. Yanıtlar, kişilerin kimliğinin tespit edilememesi için daha küçük ekiplerde birleştirilir. Sonuç puanının oluşması için soruyu, organizasyonun büyüklüğüne bağlı olarak en az 3 veya 5 kişinin cevaplamas",
      question2: "Senswise nedir? İnsan odaklı yapay zeka tam olarak nasıl çözüm sağlar?",
      answer2:
        "Senswise is an employee experience solution designed to help you collect data accurately, analyze it in real time, provide meaningful insights, and recommend a strategic action roadmap tailored to your organization, your team, and your personal needs. Senswise empowers not only organizations but also team leaders and all employees to address the most critical challenges. Although the survey questions are science-backed, they are designed to be clear, easy to understand, and written in a friendly, everyday language. To ensure that your voice is truly heard, we combine human science and data science when designing our listening mechanisms. According to Senswise, a healthy organization is only possible when the organization, team leaders, and all employees begin to think together about key issues such as employee satisfaction and retention—and take action on them collectively.",
    },
  },
};

//  dil
let currentLanguage = "tr";

const changeLanguage = (lang: string) => {
  currentLanguage = lang;
  localStorage.setItem("language", lang);

  // Mevcut URL'yi al
  const currentPath = window.location.pathname;
  const currentHash = window.location.hash;

  const pathWithoutLang = currentPath.replace(/^\/[a-z]{2}(\/|$)/, "/");

  const newPath = `/${lang}${pathWithoutLang === "/" ? "" : pathWithoutLang}${currentHash}`;

  window.history.pushState(null, "", newPath);

  window.location.reload();
};

// Çeviri fonksiyonu
const t = (key: string) => {
  const keys = key.split(".");
  let value: any = translations[currentLanguage as keyof typeof translations];

  for (const k of keys) {
    if (value && typeof value === "object" && k in value) {
      value = value[k];
    } else {
      return key; // Çeviri bulunamadıysa key'i döndür
    }
  }

  return typeof value === "string" ? value : key;
};

const getLanguageFromURL = () => {
  const path = window.location.pathname;
  const langMatch = path.match(/^\/([a-z]{2})(\/|$)/);
  return langMatch ? langMatch[1] : null;
};

const urlLanguage = getLanguageFromURL();
if (urlLanguage && (urlLanguage === "tr" || urlLanguage === "en")) {
  currentLanguage = urlLanguage;
  // URL'den alınan dili localStorage'a kaydet
  localStorage.setItem("language", urlLanguage);
} else {
  const savedLanguage = localStorage.getItem("language");
  if (savedLanguage && (savedLanguage === "tr" || savedLanguage === "en")) {
    currentLanguage = savedLanguage;
  }
}

export { t, changeLanguage, currentLanguage };
